import React from "react";
import { Box, Button, Chip } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import SaveIcon from "@material-ui/icons/Save";
import useAssistedAffiliationStyles from "../styles";

type RequestActionToolbarProps = {
  status: string;
  createDisabled: boolean;
  isCreating: boolean;
  showSubmitActions?: boolean;
  onBack: () => void;
  onSaveDraft: () => void;
  onCreateCommerce: () => void;
};

const RequestActionToolbar = ({
  status,
  createDisabled,
  isCreating,
  showSubmitActions = true,
  onBack,
  onSaveDraft,
  onCreateCommerce,
}: RequestActionToolbarProps) => {
  const classes = useAssistedAffiliationStyles();

  return (
    <Box className={classes.toolbar}>
      <Button
        className={classes.backButton}
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
      >
        Volver
      </Button>
      <Box className={classes.actions}>
        <Chip label={status} className={classes.draftChip} />
        {showSubmitActions ? (
          <>
            <Button
              className={classes.saveButton}
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={onSaveDraft}
            >
              Guardar borrador
            </Button>
            <Button
              className={classes.createButton}
              variant="contained"
              startIcon={<CheckCircleOutlineIcon />}
              disabled={createDisabled}
              onClick={onCreateCommerce}
            >
              {isCreating ? "Creando..." : "Crear comercio"}
            </Button>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default RequestActionToolbar;
